module.exports = __webpack_public_path__ + "static/media/post-07.aee29af2.png";